import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  type RepairPrice,
  type RepairPriceRequest,
} from '@service-initiation/shared-clients-tech-care-services';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';
import { type RepairPricePayload } from './types';

export const GET_REPAIR_PRICE_CACHE_KEY = 'repairPrice';

export const getRepairPrice = async ({
  address,
  deviceRepairId,
  deviceTypeId,
  geoLocation,
  serviceTypeCode,
  storeId,
}: RepairPricePayload): Promise<RepairPrice> => {
  const request: RepairPriceRequest = {
    customer_location: {
      address_1: address,
      latitude: geoLocation?.latitude,
      longitude: geoLocation?.longitude,
    },
    device_repair_id: [deviceRepairId],
    device_repair_option_item_id: [],
    device_type_id: deviceTypeId,
    referer: 'my.asurion.com/tech-care/repairs',
    service_type_code: serviceTypeCode,
    store_id: storeId,
  };
  return await queryClient.fetchQuery({
    queryFn: async () => {
      const response = await techCareServicesClient.getRepairPrice(request);

      if (response.status !== HttpStatusCodes.OK) {
        const error = new Error('Failed to get repair price');
        logger.error(error as Error, {
          data: {
            request: request,
            response: response,
          },
        });
        throw error;
      }

      return response.body.data;
    },
    queryKey: [GET_REPAIR_PRICE_CACHE_KEY, request],
    retry: 2,
    staleTime: Infinity,
  });
};
